module.exports = __webpack_public_path__ + "static/media/shukcity_big.2dec95b8.png";